import { useState } from "react";

// eslint-disable-next-line import/no-unresolved
import { CustomerSucessController } from "@talentbait/shared-components";

function useModal(campaignId) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  function handleOpenModal() {
    CustomerSucessController.send(`CampaignMembers:open`, { campaignId });
    setIsModalOpen(true);
  }

  function handleCloseModal() {
    setIsModalOpen(false);
  }

  return { isModalOpen, handleOpenModal, handleCloseModal };
}

export default useModal;
